import { Component, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { GCValidators } from '../../shared/validators/gc-validator';
import { UserService } from '../../shared/services/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss'],
})
export class PasswordResetComponent implements OnDestroy {
  private activateToken: string = '';

  error: string = '';

  resetForm = new FormGroup({
    password: new FormControl('', [Validators.required, GCValidators.validatePassword()]),
    confirmPassword: new FormControl('', [Validators.required, GCValidators.validatePasswordComparison()]),
  });

  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private router: Router,
  ) {
    route.params.takeUntil(this.ngUnsubscribe).subscribe((values) => {
      this.activateRoute(values);
    });
  }

  activateRoute(params) {
    if (params.lang) {
      this.translate.setDefaultLang(params.lang);
    }

    this.activateToken = params.token;
  }

  reset(event) {
    event.preventDefault();

    if (this.resetForm.valid) {
      this.userService.redeemPasswordReset(this.resetForm.value.password, this.activateToken).then((result) => {
        this.router.navigate(['/login']);
      });
    }
  }

  /**
   * On destroy cancel active subscriptions
   */
  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/password-reset/password-reset.component.ts